<template>
  <div class="container-fluid" v-if="isEnabled">
    <div class="mt-4">
      <Breadcrumb :breadcrumbs="breadcrumbs"/>

      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
  
  <NotFound v-else/>
</template>

<script>
  import GetAccount from '@/mixins/GetAccount'
  import GetUser from '@/mixins/GetUser'
  import Breadcrumb from '@/components/shares/Breadcrumb'
  import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'
  
  import NotFound from '@/components/shares/NotFound'

  export default {
    components: { Breadcrumb, NotFound },
    computed: {
      isEnabled() {
        return this.getAccount.metadata['unicoIntegration'] && this.getUser.role === 'owner'
      }
    },
    mixins: [BreadcrumbMixin, GetAccount, GetUser],
    name: 'UnicoIntegration'
  }

</script>

<style scoped>

</style>
